import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

/**
 * Wraps its children in a magnetic effect.
 * When the cursor is within its area, the children gently follow the cursor.
 * Effect disabled on touch devices / below lg breakpoint via CSS pointer media query
 * (we still render, but the mouse events simply won't fire on touch).
 */
export default function MagneticButton({
    children,
    className = "",
    strength = 0.3,
    as: Component = "div",
    ...rest
}) {
    const ref = useRef(null);
    const x = useMotionValue(0);
    const y = useMotionValue(0);
    const sx = useSpring(x, { damping: 15, stiffness: 140, mass: 0.4 });
    const sy = useSpring(y, { damping: 15, stiffness: 140, mass: 0.4 });

    const handleMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        x.set((e.clientX - cx) * strength);
        y.set((e.clientY - cy) * strength);
    };
    const reset = () => {
        x.set(0);
        y.set(0);
    };

    const MotionComp = motion(Component);

    return (
        <MotionComp
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={reset}
            style={{ x: sx, y: sy }}
            className={className}
            {...rest}
        >
            {children}
        </MotionComp>
    );
}
